const translations = {
  "en": {
    "Back": "Back",
    "Finish these and Ed will know you well enough to do all of it better.": "Finish these and Ed will know you well enough to do all of it better.",
    "Get Ed working better for you": "Get Ed working better for you",
    "Retry": "Retry",
    "Setup checklist with Ed": "Setup checklist with Ed",
    "The more Ed knows you, the better Ed works for you": "The more Ed knows you, the better Ed works for you",
    "Unable to sync latest setup progress.": "Unable to sync latest setup progress."
  },
  "zh-tw": {
    "Back": "返回",
    "Finish these and Ed will know you well enough to do all of it better.": "完成這些設定後，Ed 將能充分掌握您的投資偏好，為您提供更精準的服務。",
    "Get Ed working better for you": "提升 Ed 的表現，更好地為您服務",
    "Retry": "重試",
    "Setup checklist with Ed": "搭配 Ed 的設定清單",
    "The more Ed knows you, the better Ed works for you": "Ed 越了解您，為您服務的表現就越好。",
    "Unable to sync latest setup progress.": "無法同步最新設定進度。"
  }
};

export default translations;
